import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../../lib/api";
import PremiumLayout from "./PremiumLayout";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
}

export default function PremiumBlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/marketing/blog?limit=100")
      .then(({ data }) => setPosts(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <PremiumLayout>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-8" data-testid="blog-header">
        <div className="gold text-[11px] tracking-[.16em] uppercase">Studio Journal</div>
        <h1 className="text-5xl md:text-7xl leading-[1.02] mt-4">
          Notes from <span className="gold italic">the studio.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-[#B8B0A0] text-lg leading-relaxed">
          Essays, project reflections and design notes from our architects — a slow-paced journal about
          how we think about spaces, materials, and the people who live in them.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-14">
        {loading ? (
          <div className="py-32 text-center gold">Loading…</div>
        ) : posts.length === 0 ? (
          <div className="py-32 text-center text-[#7A7267]">No posts published yet.</div>
        ) : (
          <div className="flex flex-col gap-8" data-testid="blog-list">
            {posts.map((p) => <BlogCard key={p.id} p={p} />)}
          </div>
        )}
      </section>
    </PremiumLayout>
  );
}

function BlogCard({ p }) {
  return (
    <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
          className="group grid md:grid-cols-[440px_1fr] gap-0 border border-[#1F1F1F] hover:border-[#C9A96E] transition-colors overflow-hidden">
      {p.cover_image_url ? (
        <div className="relative aspect-[4/3] md:aspect-auto md:h-full overflow-hidden">
          <img src={p.cover_image_url} alt={p.title}
               className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
        </div>
      ) : (
        <div className="hidden md:block bg-[#141414]" />
      )}
      <div className="p-6 md:p-8 flex flex-col justify-center">
        <div className="flex items-center justify-between text-[11px] tracking-[.16em] uppercase text-[#9A9284]">
          <span className="gold">{p.tag || "Journal"}</span>
          <span>{formatDate(p.published_at || p.created_at)}</span>
        </div>
        <div className="text-2xl md:text-3xl mt-4 leading-tight">{p.title}</div>
        {p.excerpt && <p className="mt-4 text-[#B8B0A0] leading-relaxed text-base line-clamp-3">{p.excerpt}</p>}
        <div className="mt-5 flex items-center justify-between">
          <span className="text-sm text-[#B8B0A0]">By <span className="cream">{p.author || "Studio DHP"}</span></span>
          <span className="gold text-sm">Read the note →</span>
        </div>
      </div>
    </Link>
  );
}
